"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _executionListener = _interopRequireDefault(require("_c/Flowable/nodePanel/property/executionListener"));
var _default = exports.default = {
  components: {
    executionListenerDialog: _executionListener.default
  },
  data: function data() {
    return {
      executionListenerLength: 0,
      dialogName: null
    };
  },
  methods: {
    computedExecutionListenerLength: function computedExecutionListenerLength() {
      var len = this.element.businessObject.extensionElements.values.length;
      this.executionListenerLength = len === null || len === undefined ? 0 : len;
    },
    finishExecutionListener: function finishExecutionListener() {
      if (this.dialogName === 'executionListenerDialog') {
        this.computedExecutionListenerLength();
      }
      this.dialogName = '';
    }
  }
};